"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pitOperationTypes = void 0;
exports.pitOperationTypes = {
    SET_DATA_GRID: 'PIT OPERATION TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'PIT OPERATION TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'PIT OPERATION TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'PIT OPERATION TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'PIT OPERATION TYPES ON SAVE DATAITEM',
    GET_DETAIL: 'PIT OPERATION TYPES ON GET DETAIL',
    GET_AREA: 'PIT OPERATION TYPES ON GET AREA',
    GET_CHECKPOINT: 'PIT OPERATION TYPES ON GET CHECKPOINT',
    GET_SEAM: 'PIT OPERATION TYPES ON GET SEAM',
    GET_DUMPTRUCK: 'PIT OPERATION TYPES ON GET DUMPTRUCK',
    RESET_DUMPTRUCK: 'PIT OPERATION TYPES ON RESET DUMPTRUCK',
    GET_EXCAVATOR: 'PIT OPERATION TYPES ON GET EXCAVATOR',
    ON_FILTER_CHANGE: 'PIT OPERATION TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'PIT OPERATION TYPES ON SORT CHANGE',
    ON_DELETE: 'PIT OPERATION TYPES ON DELETE',
    SET_ERROR: 'PIT OPERATION TYPES REDUCER SET ERROR',
    ON_EXPAND_GRID: 'PIT OPERATION TYPES REDUCER ON EXPAND GRID',
    ON_FILTER_CHILD: 'PIT OPERATION TYPES REDUCER ON FILTER CHILD',
    ON_DELETE_ALL_PIT_OPERATION: 'PIT OPERATION TYPES REDUCER ON DELETE ALL PIT OPERATION',
};
